"use client";
import { useEffect, useState } from "react";

import { useIntersection } from "./useIntersection";

export const useInView = (ref: any, { once = true, threshold = 0.1 }: { once?: boolean; threshold?: number }) => {
  const entry = useIntersection(ref, { threshold });
  const [hasIntersected, setHasIntersected] = useState(false);
  const isIntersecting = entry?.isIntersecting ?? false;

  useEffect(() => {
    if (isIntersecting && once) {
      setHasIntersected(true);
    }
  }, [isIntersecting, once]);

  return once ? hasIntersected : isIntersecting;
};
